import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Sidebar from "./components/sidebar/Sidebar";
import HaversineCalculator from "./components/haversine/HaversineCalculator";
import ViewMap from "./components/MapComponent";
import BoundingBoxCalculator from "./components/boundingBox/BoundingBoxCalculator";
import GreatCircleRoute from "./components/greatCircle/GreatCircleRoute";
import MidPointCalculator from "./components/midpoint/MidpointCalculator";
import VincentyCalculator from "./components/vincenty/VincentyCalculator";
import AboutUs from "./components/about-us/AboutUs";

import "./App.css";

const App = () => {
  return (
    <Router>
      <div className="layout">
        <Sidebar />
        <main className="utility-container">
          <Routes>
            <Route path="/" element={<HaversineCalculator />} />
            <Route path="/bounding-box" element={<BoundingBoxCalculator />} />
            <Route path="/great-circle" element={<GreatCircleRoute />} />
            <Route path="/mid-point" element={<MidPointCalculator />} />
            <Route path="/vincenty-calculator" element={<VincentyCalculator />} />
            <Route path="/about" element={<AboutUs/>} />
          </Routes>
        </main>
      </div>
    </Router>
  );
};

export default App;